import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { get } from "../../utility/fetch";
import UpdateModal from "../layouts/UpdateModal";
import UpdateModalToAccount from "../layouts/UpdateModalToAccount";
import { GridLoader } from "react-spinners";
import { BsArrowDown } from "react-icons/bs";
import PreviewModal from "../layouts/PreviewModal";
import Suggestions from "../UI/Suggestions";

function DiagnosisTable({ data }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [diagnosis, setDiagnosis] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [other, setOther] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [type, setType] = useState("");

  const [previewData, setPreviewData] = useState(null);
  const [suggestPayload, setSuggestPayload] = useState({
    medications: [],
    patientId: 0,
  });
  const [patientId, setPatientId] = useState(null);
  const [activeTab, setActiveTab] = useState("unpaid"); // 'paid' or 'unpaid'

  const getPatientDiagnosis = async (id) => {
    setLoading(true);
    // let res = await get(`/patient/${id}`);
    let res = await get(`/patient/${id}/to-be-sent-to-finance`);
    console.log(res);
    // let list = res.resultList.find((e) => e.id == id);
    // console.log(id);
    // console.log(list);
    // res = list;

    if (res) {
      // Merge treatments and serviceTreatments into a single res
      const combinedTreatments = [
        ...(res.treatments || []).map((t) => ({ ...t, source: "treatment" })),
        ...(res.serviceTreatments || []).map((s) => ({
          ...s,
          source: "serviceTreatment",
        })),
      ];
      setDiagnosis(combinedTreatments);
    }
    setLoading(false);
  };

  const getPatientDiagnosisWaitingPayment = async (id) => {
    setLoading(true);
    let res = await get(`/patient/${id}/un-paid`);
    // let list = res.resultList.find((e) => e.id == id);
    if (res) {
      // Merge treatments and serviceTreatments into a single list
      const combinedTreatments = [
        ...(res.treatments || []).map((t) => ({ ...t, source: "treatment" })),
        ...(res.serviceTreatments || []).map((s) => ({
          ...s,
          source: "serviceTreatment",
        })),
      ];
      setDiagnosis(combinedTreatments);
    }
    setLoading(false);
  };

  const getPatientDiagnosisPaid = async (id) => {
    setLoading(true);
    getPaidAndEmergencyAppointments(id);
    // try {
    //   if (res) {
    //     // Merge treatments and serviceTreatments into a single list
    //     const combinedTreatments = [
    //       ...(res.treatments || []).map((t) => ({ ...t, source: "treatment" })),
    //       ...(res.serviceTreatments || []).map((s) => ({
    //         ...s,
    //         source: "serviceTreatment",
    //       })),
    //     ];
    //     setDiagnosis(combinedTreatments);
    //   }
    // } catch (error) {
    //   console.error("Error fetching paid diagnosis:", error);
    //   setDiagnosis([]);

    // }
    setLoading(false);
  };

  // Fetch paid and emergency appointments for a patient
  const getPaidAndEmergencyAppointments = async (id) => {
    setLoading(true);
    console.log(patientId);
    try {
      let res = await get(
        `/patient/${id}/paid`
      );
      // console.log(res.resultList.filter((e) => e.id == 100));
      // let list = res.resultList.find((e) => id == e.id) || [];
      if (res) {
        // Merge treatments and serviceTreatments into a single list
        const combinedTreatments = [
          ...(res.treatments || []).map((t) => ({
            ...t,
            source: "treatment",
          })),
          ...(res.serviceTreatments || []).map((s) => ({
            ...s,
            source: "serviceTreatment",
          })),
        ];
        setDiagnosis(combinedTreatments);
      }
    } catch (error) {
      console.error("Error fetching paid and emergency appointments:", error);
      setDiagnosis([]);
    }
    setLoading(false);
  };

  const getPatientDiagnosisDispensed = async (id) => {
    setLoading(true);
    try {
      let res = await get(`/patient/${id}/is-dispensed`);
      // let list = res.resultList.find((e) => e.id == id);
      console.log(res);
      if (res) {
        // Merge treatments and serviceTreatments into a single res
        const combinedTreatments = [
          ...(res.treatments || []).map((t) => ({
            ...t,
            source: "treatment",
          })),
          ...(res.serviceTreatments || []).map((s) => ({
            ...s,
            source: "serviceTreatment",
          })),
        ];
        setDiagnosis(combinedTreatments);
      }
    } catch (error) {
      setDiagnosis([]);
    }
    setLoading(false);
  };

  const handleTabChange = (tab = "unpaid") => {
    setActiveTab(tab);
    // alert(tab);
    const patientId = searchParams.get("id");

    if (tab === "paid") {
      getPatientDiagnosisPaid(patientId);
      getPaidAndEmergencyAppointments(patientId);
    } else if (tab === "waitingPayment") {
      getPatientDiagnosisWaitingPayment(patientId);
    } else if (tab == "dispensed") {
      getPatientDiagnosisDispensed(patientId);
    } else if ((tab = "unpaid")) {
      getPatientDiagnosis(patientId);
    }
  };

  const handlePreview = (item) => {
    setPreviewModal(true);
    setPreviewData(item);
    console.log(item);
  };

  const handleButtonClick = (row, item) => {
    setModalData(item);
    console.log("Button clicked for row:", row);
    setSelectedRow(row);
    setIsModalOpen(true);
  };

  const handleOtherButtonClick = (row, item) => {
    setModalData(item);
    console.log("Button clicked for row:", row);
    setOther(true);
    setSelectedRow(row);
    setIsModalOpen(true);
  };

  const handleRow = (row) => {
    console.log("Row clicked:", row);
    const medications = [
      ...(row?.prescriptions || []).map(
        (p) => p?.pharmacyInventory?.productName || p?.name || "NIL"
      ),
      ...(row?.otherPrescriptions || []).map((op) => op?.name || "NIL"),
    ];

    console.log("Medications:", medications);

    // Update suggestPayload with the combined list
    setPatientId(row?.patientId);
    setSuggestPayload({ medications: medications, patientId: row?.patientId });
  };

  useEffect(() => {
    console.log(data);
    const patientId = searchParams.get("patientId");
    setType(searchParams.get("type"));
    console.log(patientId);
    setPatientId(patientId);

    if (searchParams.get("type") === "paid") {
      getPatientDiagnosisPaid(searchParams.get("patientId"));
      setActiveTab("paid");
    } else if (searchParams.get("type") === "awaiting") {
      getPatientDiagnosisWaitingPayment(searchParams.get("patientId"));
      setActiveTab("waitingPayment");
    } else if (searchParams.get("type") === "unsent") {
      getPatientDiagnosis(searchParams.get("patientId"));
      setActiveTab("unpaid");
    } else if (searchParams.get("type") === "dispensed") {
      getPatientDiagnosisDispensed(searchParams.get("patientId"));
      setActiveTab("dispensed");
    }
  }, []);

  const frequencyMap = {
    1: 1, // Immediately
    2: 1, // As needed
    3: 1, // Once daily
    4: 2, // Twice a day
    5: 3, // Three times a day
    6: 4, // Four times a day
    7: 1, // At night
    8: 1, // Morning
    9: 1, // Evening
    10: 1, // Every 24 hours
    11: 2, // Every 12 hours
    12: 3, // Every 8 hours
    13: 4, // Every 6 hours
    14: 6, // Every 4 hours
    15: 8, // Every 3 hours
    16: 12, // Every 2 hours
    17: 24, // Every hour
    18: 1, // Every 2 months
    19: 1, // Every 3 months
  };

  const administrationFrequencies = [
    { id: 1, name: "Immediately" },
    { id: 2, name: "As needed" },
    { id: 3, name: "Once daily" },
    { id: 4, name: "Twice a day" },
    { id: 5, name: "Three times a day" },
    { id: 6, name: "Four times a day" },
    { id: 7, name: "At night" },
    { id: 8, name: "Morning" },
    { id: 9, name: "Evening" },
    { id: 10, name: "Every 24 hours" },
    { id: 11, name: "Every 12 hours" },
    { id: 12, name: "Every 8 hours" },
    { id: 13, name: "Every 6 hours" },
    { id: 14, name: "Every 4 hours" },
    { id: 15, name: "Every 3 hours" },
    { id: 16, name: "Every 2 hours" },
    { id: 17, name: "Every hour" },
    { id: 18, name: "Every 2 months" },
    { id: 19, name: "Every 3 months" },
  ];

  const drugStrengthUnits = [
    { id: 0, name: "Milligrams" },
    { id: 1, name: "Grams" },
    { id: 2, name: "Micrograms" },
    { id: 3, name: "Milliliters" },
    { id: 4, name: "Liters" },
    { id: 5, name: "Units" },
    { id: 6, name: "Puffs" },
    { id: 7, name: "Sprays" },
    { id: 8, name: "Drops" },
    { id: 9, name: "Patch" },
    { id: 10, name: "Bottle" },
    { id: 11, name: "TransdermalSystem" },
    { id: 12, name: "Tablet" },
    { id: 13, name: "Capsule" },
    { id: 14, name: "Suppository" },
    { id: 15, name: "Scoop" },
    { id: 16, name: "Sachet" },
    { id: 17, name: "Ampoule" },
    { id: 18, name: "Vial" },
    { id: 19, name: "InjectionPen" },
    { id: 20, name: "Enema" },
    { id: 21, name: "Ounces" },
    { id: 22, name: "Teaspoon" },
    { id: 23, name: "Tablespoon" },
    { id: 24, name: "Milliequivalents" },
    { id: 25, name: "InternationalUnits" },
  ];

  const routesOfAdministration = [
    { id: 1, name: "Orally" },
    { id: 2, name: "Sublingual" },
    { id: 3, name: "Topical" },
    { id: 4, name: "Inhalation" },
    { id: 5, name: "Suppository" },
    { id: 6, name: "IV" },
    { id: 7, name: "IM" },
    { id: 8, name: "Subcut" },
    { id: 9, name: "Intradermal" },
    { id: 10, name: "PerRectum" },
    { id: 11, name: "PerVagina" },
    { id: 12, name: "Implant" },
  ];

  console.log(diagnosis);

  return (
    <div className="w-100">
      {/* Back Button */}
      <button
        className="btn m-b-20"
        style={{
          background: "#f8f9fa",
          color: "#333",
          border: "2px solid #e1e5e9",
          fontWeight: "600",
          padding: "10px 24px",
          borderRadius: "8px",
          cursor: "pointer",
          marginBottom: "20px",
        }}
        onClick={() => navigate(-1)}
      >
        ← Back
      </button>
      {/* Tab Buttons */}
      <div className="m-t-20 m-b-20">
        {type === "unsent" && (
          <button
            className="btn m-r-20"
            style={{
              background:
                activeTab === "unpaid"
                  ? "linear-gradient(135deg, #fbca34ff 0%, #fbca34ff 100%)"
                  : "#f8f9fa",
              color: activeTab === "unpaid" ? "black" : "#6c757d",
              border: activeTab === "unpaid" ? "none" : "2px solid #e1e5e9",
              fontWeight: "600",
              padding: "12px 24px",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow:
                activeTab === "unpaid"
                  ? "0 4px 12px rgba(255, 193, 7, 0.3)"
                  : "0 2px 4px rgba(0,0,0,0.1)",
            }}
            onClick={() => handleTabChange("unpaid")}
          >
            Send To Finance
          </button>
        )}
        {type === "awaiting" && (
          <button
            className="btn m-r-20"
            style={{
              background:
                activeTab === "waitingPayment"
                  ? "linear-gradient(135deg, #fbca34ff 0%, #fbca34ff 100%)"
                  : "#f8f9fa",
              color: activeTab === "waitingPayment" ? "black" : "#6c757d",
              border:
                activeTab === "waitingPayment" ? "none" : "2px solid #e1e5e9",
              fontWeight: "600",
              padding: "12px 24px",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow:
                activeTab === "wa"
                  ? "0 4px 12px rgba(255, 193, 7, 0.3)"
                  : "0 2px 4px rgba(0,0,0,0.1)",
            }}
            onClick={() => handleTabChange("waitingPayment")}
          >
            Unpaid Finance
          </button>
        )}
        {type === "paid" && (
          <button
            className="btn"
            style={{
              background:
                activeTab === "paid"
                  ? "linear-gradient(135deg, #28a745 0%, #20c997 100%)"
                  : "#f8f9fa",
              color: activeTab === "paid" ? "white" : "#6c757d",
              border: activeTab === "paid" ? "none" : "2px solid #e1e5e9",
              fontWeight: "600",
              padding: "12px 24px",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow:
                activeTab === "paid"
                  ? "0 4px 12px rgba(40, 167, 69, 0.3)"
                  : "0 2px 4px rgba(0,0,0,0.1)",
            }}
            onClick={() => handleTabChange("paid")}
          >
            Paid Prescriptions
          </button>
        )}
        {type === "dispensed" && (
          <button
            className="btn"
            style={{
              background:
                activeTab === "dispensed"
                  ? "linear-gradient(135deg, #28a745 0%, #20c997 100%)"
                  : "#f8f9fa",
              color: activeTab === "dispensed" ? "white" : "#6c757d",
              border: activeTab === "dispensed" ? "none" : "2px solid #e1e5e9",
              fontWeight: "600",
              padding: "12px 24px",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow:
                activeTab === "dispensed"
                  ? "0 4px 12px rgba(40, 167, 69, 0.3)"
                  : "0 2px 4px rgba(0,0,0,0.1)",
            }}
            onClick={() => handleTabChange("dispensed")}
          >
            Dispensed Prescriptions
          </button>
        )}
      </div>

      <div className="w-100 none-flex-item m-t-20">
        <table className="bordered-table">
          <thead className="border-top-none">
            <tr className="border-top-none">
              <th></th>
              <th>Date</th>
              <th>Diagnosis</th>
              <th>Medication/Prescription</th>
              <th>Drug Strength</th>
              <th>Qty</th>
              <th>Frequency</th>
              <th>Route of Administration</th>
              <th>Duration(Days)</th>
              <th>Dispensed Date</th>
              <th>Pharmacist's Note</th>
            </tr>
          </thead>

          {loading ? (
            <div
              style={{ paddingLeft: "500px", paddingTop: "200px" }}
              className="flex flex-h-center w-100 flex-v-center"
            >
              <GridLoader />
            </div>
          ) : (
            <tbody className="white-bg view-det-pane">
              {diagnosis.map((row, rowIndex) => (
                <React.Fragment key={row?.id}>
                  <tr className="pointer" onClick={() => handleRow(row)}>
                    <td
                      rowSpan={
                        row?.prescriptions.length +
                        row?.otherPrescriptions?.length +
                        1
                      }
                    >
                      <BsArrowDown
                        size={20}
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePreview(row);
                        }}
                        className="pointer"
                      />
                    </td>
                    <td
                      rowSpan={
                        row?.prescriptions.length +
                        row?.otherPrescriptions?.length +
                        1
                      }
                    >
                      {new Date(row?.dateOfVisit)?.toLocaleDateString()}
                    </td>
                    <td
                      rowSpan={
                        row?.prescriptions.length +
                        row?.otherPrescriptions?.length +
                        1
                      }
                    >
                      {row?.diagnosis}
                    </td>
                  </tr>
                  {[...row?.prescriptions, ...row?.otherPrescriptions].map(
                    (item, index) => (
                      <tr key={index}>
                        <td>
                          {item?.pharmacyInventory?.productName ||
                            item?.name ||
                            "NIL"}
                        </td>
                        <td>
                          {item?.pharmacyInventory?.strength ||
                            item?.strength ||
                            item.doctorPrescription?.strength ||
                            "N/A"}
                        </td>
                        <td>
                          {item.quantity}{" "}
                          {drugStrengthUnits.find(
                            (unit) => unit.id === item?.drugStrengthUnit
                          )?.name ||
                            item.doctorPrescription?.drugStrengthUnit ||
                            "N/A"}
                        </td>
                        <td>
                          {administrationFrequencies.find(
                            (freq) => freq.id === item.administrationFrequency
                          )?.name ||
                            item.doctorPrescription?.administrationFrequency ||
                            "N/A"}
                        </td>
                        <td>
                          {routesOfAdministration.find(
                            (route) => route.id === item.routeOfAdministration
                          )?.name ||
                            item.doctorPrescription?.routeOfAdministration ||
                            "N/A"}
                        </td>
                        <td>{item.duration} days</td>
                        <td>
                          {item.dispensedDate
                            ? new Date(item.dispensedDate).toLocaleDateString()
                            : "-"}
                        </td>
                        {activeTab === "waitingPayment" ? (
                          <td></td>
                        ) : item?.medId ? (
                          <td>
                            {item?.isDispensed ? (
                              item.pharmacistNote
                            ) : (
                              <div className="flex">
                                <button
                                  className="btn m-r-20"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleButtonClick(row, item);
                                  }}
                                >
                                  Action
                                </button>
                              </div>
                            )}
                          </td>
                        ) : (
                          <td>
                            <div className="flex">
                              <button
                                className="btn m-r-20"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOtherButtonClick(row, item);
                                }}
                              >
                                Action
                              </button>
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  )}
                  {rowIndex < diagnosis.length - 1 && (
                    <tr>
                      <td
                        colSpan={9}
                        style={{ height: "20px", backgroundColor: "lightgrey" }}
                      ></td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          )}
        </table>
      </div>

      {/* Conditional Modal Rendering based on activeTab */}
      {isModalOpen && activeTab === "unpaid" && (
        <UpdateModalToAccount
          data={selectedRow}
          other={other}
          diagnosis={diagnosis}
          getPatientDiagnosis={getPatientDiagnosis}
          modalData={modalData}
          treatments={diagnosis}
          closeModal={() => {
            setOther(false);
            setIsModalOpen(false);
            setActiveTab("unpaid");
          }}
        />
      )}

      {isModalOpen && activeTab === "paid" && (
        <UpdateModal
          data={selectedRow}
          other={other}
          diagnosis={diagnosis}
          getPatientDiagnosis={getPatientDiagnosisPaid}
          modalData={modalData}
          treatments={diagnosis}
          closeModal={() => {
            setOther(false);
            setIsModalOpen(false);
            setActiveTab("paid");
          }}
        />
      )}

      {previewModal && (
        <PreviewModal
          data={previewData}
          closeModal={() => setPreviewModal(false)}
        />
      )}

      {suggestPayload && (
        <Suggestions payload={suggestPayload} patientId={patientId} />
      )}
    </div>
  );
}

export default DiagnosisTable;
